import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";
import { REQUEST_ID_HEADER, extractRequestId } from "./lib/request-id";
import { captureServerException } from "./lib/sentry-server";

const requestIdMiddleware = createMiddleware().server(async ({ next, request }) => {
  const requestId = extractRequestId(request.headers);
  // Expose via a request header for downstream readers.
  try {
    (request.headers as Headers).set(REQUEST_ID_HEADER, requestId);
  } catch {
    // headers may be immutable in some runtimes; safe to ignore
  }
  return next({ context: { requestId } });
});

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  const requestId = extractRequestId(request.headers);
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(JSON.stringify({ level: "error", msg: "request_middleware_error", requestId, url: request.url, error: String(error) }));
    captureServerException(error, { requestId, url: request.url });
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8", [REQUEST_ID_HEADER]: requestId },
    });
  }
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [requestIdMiddleware, errorMiddleware],
}));
